module.exports = __webpack_public_path__ + "img/2-2.9a438c0f.svg";